import React, { SVGAttributes } from "react";

type Props = SVGAttributes<SVGSVGElement>;

// Outlined Play triangle for the Android download CTA.
const GooglePlayLogo: React.FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M6 3l14 9-14 9V3z" />
    </svg>
  );
};

export default GooglePlayLogo;
